import React, { PropTypes } from 'react';
import classnames from 'classnames';

export default class Quote extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  render() {
    const text = this.props.children;

    const styles = {
      wrapper: classnames({
        quote: true,
      }),
      textContainer: classnames({
        'quote--text-container': true,
      }),
      baseContainer: classnames({
        'quote--base-container': true,
      }),
    };

    return (
      <blockquote className={styles.wrapper}>
        <div className={styles.textContainer}><span>{text}</span></div>
        <div className={styles.baseContainer}><span>{text}</span></div>
      </blockquote>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/Quote.jsx
 **/